export default {
  selection: "System Language Selection",
  english: "English",
  simplified_chinese: "中文（简体）",
  list: {
    en: "Inglés",
    zh: "Chino (CN)",
    tw: "Chino (TW)",
    vi: "Vietnamita",
    th: "Tailandés",
    id: "Indonesio",
    malay: "Malayo",
    jp: "Japonés",
    kr: "Coreano",
    my: "Birmano",
    ar: "Argentina",
    ru: "Rusia"
  }
};
